import React from "react";

export const SearchResultCard = (props: {
  onClick: () => void;
  children: React.ReactNode;
  dataCy?: string;
}) => {
  return (
    <div
      data-cy={props.dataCy}
      onClick={props.onClick}
      className="m-1 rounded-card border border-line bg-surface-card px-[5px] py-[3px] shadow-card"
    >
      {props.children}
    </div>
  );
};
